"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateTime = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var isNumber = (0, type_guard_1.is)((0, type_guard_1.number)());
var isDate = (0, type_guard_1.is)((0, type_guard_1.instanceOf)(Date));
var isISO8601 = (0, type_guard_1.is)((0, type_guard_1.format)('date-iso8601'));
var pick = function (obj, keys) {
    return Object.fromEntries(Object.entries(obj).filter(function (_a) {
        var _b = __read(_a, 1), key = _b[0];
        return keys.includes(key);
    }));
};
function formatDateTime(value, options) {
    var _a = __assign({}, options), locale = _a.locale, timeZone = _a.timeZone, style = _a.style, hourCycle = _a.hourCycle;
    var locales = locale === undefined ? [] : [locale];
    var dateStyleOptions = style === undefined
        ? { dateStyle: 'medium' }
        : style === 'medium-weekday'
            ? { year: 'numeric', month: 'short', day: 'numeric', weekday: 'short' }
            : typeof style === 'object'
                ? pick(style, ['weekday', 'year', 'month', 'day'])
                : { dateStyle: style };
    var timeStyleOptions = style === undefined
        ? { timeStyle: 'medium' }
        : style === 'medium-weekday'
            ? { hour: 'numeric', minute: 'numeric', second: 'numeric' }
            : typeof style === 'object'
                ? pick(style, ['hour', 'minute', 'second'])
                : { timeStyle: style };
    var timeZoneName = (typeof style === 'object' ? style : { timeZoneName: undefined }).timeZoneName;
    var formatter = new Intl.DateTimeFormat(locales, __assign(__assign(__assign(__assign({}, dateStyleOptions), timeStyleOptions), { hourCycle: hourCycle }), { timeZone: timeZone, timeZoneName: timeZoneName }));
    if (isNumber(value) || isDate(value)) {
        return formatter.format(value);
    }
    else if (isISO8601(value)) {
        var date = new Date(value);
        return formatter.format(date);
    }
    else {
        throw new type_guard_1.FunctionAssertionError('formatDateTime', 1, [
            {
                path: [0],
                rule: 'type',
                setting: ['Date', 'number', 'format-date-iso-8601'],
                actual: value
            }
        ]);
    }
}
exports.formatDateTime = formatDateTime;
//# sourceMappingURL=format-date-time.js.map